import type { BrandInterface, OptionType } from '@/types'

import type {
  ProductSupplierDto,
  StockImportConfigModel,
  StockImportConfigShortModel,
  StoreModel,
} from '../../types/stockImports.types'
import { buildCronOptions, buildSourceTypeOptions } from './configModalTexts'
import { buildConfigStoreOptions } from './configStoreOptions'

type ConfigOptionsParams = {
  config: StockImportConfigModel | null
  savedConfigId: string | undefined
  suppliers: ProductSupplierDto[]
  stores: StoreModel[]
  configs: StockImportConfigShortModel[]
  brands: BrandInterface[]
  isSelfSupplierMode: boolean
  supplierId: string
  cronExpression: string
}

const toOption = (value: string, label: string): OptionType => ({
  value,
  label,
})

export const buildConfigOptions = ({
  config,
  savedConfigId,
  suppliers,
  stores,
  configs,
  brands,
  isSelfSupplierMode,
  supplierId,
  cronExpression,
}: ConfigOptionsParams) => ({
  store: buildConfigStoreOptions({
    stores,
    configs,
    isSelfSupplierMode,
    supplierId,
    excludeConfigIds: [config?.id, savedConfigId],
    originalStoreId: config?.store?.id,
  }),
  suppliers: suppliers.map((item) => toOption(item.id, item.description)),
  sourceTypes: buildSourceTypeOptions(config?.sourceType),
  cron: buildCronOptions(cronExpression),
  brands: brands.map((brand) => toOption(brand.id, brand.description)),
  brandNames: brands.map((brand) =>
    toOption(brand.description, brand.description)
  ),
})
